var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 172.139 172.139",
    style: {
      enableBackground: "new 0 0 172.139 172.139"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC5918"
    },
    d: "M84.569,72.528c-16.932,0.757-33.739,11.889-33.662,32.39l0.153,22.713 c0.08,21.309,16.573,31.488,33.509,31.48V72.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#774730"
    },
    d: "M84.569,72.528c16.938,0.629,33.434,11.635,33.511,32.136l0.152,22.712 c0.081,21.31-16.727,31.614-33.663,31.735V72.528z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5742A"
    },
    d: "M84.568,92.54c-13.609,0.827-24.428,14.013-24.428,30.157c0,16.145,10.818,29.332,24.428,30.158 V92.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC5918"
    },
    d: "M84.57,92.54c13.609,0.827,24.428,14.013,24.428,30.157c0,16.145-10.818,29.332-24.428,30.158 V92.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0874B"
    },
    d: "M49.536,79.398C39.262,79.886,31.22,87.661,31.22,97.182c0,9.52,8.042,17.297,18.315,17.783 V79.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5742A"
    },
    d: "M49.536,79.398C59.808,79.886,68.1,87.661,68.1,97.182c0,9.52-8.292,17.297-18.564,17.783V79.398z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0874B"
    },
    d: "M119.355,79.398c-10.273,0.487-18.314,8.263-18.314,17.783c0,9.52,8.041,17.297,18.314,17.783 V79.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5742A"
    },
    d: "M119.355,79.398c10.271,0.487,18.564,8.263,18.564,17.783c0,9.52-8.293,17.297-18.564,17.783 V79.398z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M59.228,101.857c0,5.285-4.408,9.568-9.692,9.568c-5.285,0-9.443-4.283-9.443-9.568 c0-5.284,4.158-9.567,9.443-9.567C54.82,92.29,59.228,96.573,59.228,101.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M53.914,86.619c0,2.349-2.029,4.252-4.378,4.252c-2.349,0-4.128-1.903-4.128-4.252 c0-2.349,1.779-4.253,4.128-4.253C51.884,82.366,53.914,84.271,53.914,86.619z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 39.029,
    cy: 89.453,
    r: 4.252
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 60.291,
    cy: 89.453,
    r: 4.253
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M49.536,92.29c-0.169,0,0.167,0.017,0,0.025V111.4c0.167,0.009-0.169,0.025,0,0.025 c5.284,0,9.692-4.283,9.692-9.568C59.228,96.573,54.82,92.29,49.536,92.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M49.536,82.366c-0.171,0,0.166,0.03,0,0.051v8.403c0.166,0.021-0.171,0.051,0,0.051 c2.349,0,4.378-1.903,4.378-4.252C53.914,84.271,51.884,82.366,49.536,82.366z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#232221"
    },
    cx: 60.291,
    cy: 89.453,
    r: 4.253
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M129.048,101.857c0,5.285-4.409,9.568-9.693,9.568c-5.285,0-9.443-4.283-9.443-9.568 c0-5.284,4.158-9.567,9.443-9.567C124.639,92.29,129.048,96.573,129.048,101.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M123.732,86.619c0,2.349-2.029,4.252-4.377,4.252c-2.35,0-4.129-1.903-4.129-4.252 c0-2.349,1.779-4.253,4.129-4.253C121.703,82.366,123.732,84.271,123.732,86.619z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 108.848,
    cy: 89.453,
    r: 4.253
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 130.11,
    cy: 89.453,
    r: 4.252
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M119.355,92.29c-0.17,0,0.166,0.017,0,0.025V111.4c0.166,0.009-0.17,0.025,0,0.025 c5.284,0,9.693-4.283,9.693-9.568C129.048,96.573,124.639,92.29,119.355,92.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M119.355,82.366c-0.172,0,0.166,0.03,0,0.051v8.403c0.166,0.021-0.172,0.051,0,0.051 c2.348,0,4.377-1.903,4.377-4.252C123.732,84.271,121.703,82.366,119.355,82.366z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#232221"
    },
    cx: 130.11,
    cy: 89.453,
    r: 4.252
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AC5918"
    },
    points: "32.982,172.139 86.222,159.111 52.986,134.805 32.982,136.572  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0874B"
    },
    d: "M32.982,136.572c-10.273,0.487-18.853,8.263-18.853,17.783c0,9.52,8.58,17.296,18.853,17.783 V136.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5742A"
    },
    d: "M32.982,136.572c10.272,0.487,18.027,8.263,18.027,17.783c0,9.52-7.755,17.296-18.027,17.783 V136.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M42.923,158.857c0,5.285-4.656,9.568-9.941,9.568s-9.195-4.283-9.195-9.568 c0-5.284,3.91-9.567,9.195-9.567S42.923,153.573,42.923,158.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M37.607,143.619c0,2.349-2.276,4.252-4.625,4.252c-2.35,0-3.88-1.903-3.88-4.252 c0-2.349,1.53-4.253,3.88-4.253C35.331,139.366,37.607,141.27,37.607,143.619z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 22.723,
    cy: 146.453,
    r: 4.253
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 43.986,
    cy: 146.453,
    r: 4.252
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M32.982,149.29c-0.169,0,0.166,0.017,0,0.025V168.4c0.166,0.009-0.169,0.025,0,0.025 c5.285,0,9.941-4.283,9.941-9.568C42.923,153.573,38.267,149.29,32.982,149.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M32.982,139.366c-0.172,0,0.166,0.03,0,0.051v8.403c0.166,0.02-0.172,0.051,0,0.051 c2.349,0,4.625-1.903,4.625-4.252C37.607,141.27,35.331,139.366,32.982,139.366z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#232221"
    },
    cx: 43.986,
    cy: 146.453,
    r: 4.252
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#774730"
    },
    points: "137.255,172.139 83.602,159.111 116.837,134.805 137.255,136.572  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0874B"
    },
    d: "M139.445,136.572c-10.273,0.487-18.315,8.263-18.315,17.783c0,9.52,8.042,17.296,18.315,17.783 V136.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5742A"
    },
    d: "M139.445,136.572c10.273,0.487,18.564,8.263,18.564,17.783c0,9.52-8.291,17.296-18.564,17.783 V136.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M149.138,159.357c0,5.285-4.408,9.568-9.693,9.568c-5.285,0-9.443-4.283-9.443-9.568 c0-5.284,4.158-9.567,9.443-9.567C144.73,149.79,149.138,154.073,149.138,159.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M143.822,144.119c0,2.349-2.029,4.252-4.377,4.252c-2.35,0-4.129-1.903-4.129-4.252 c0-2.349,1.779-4.253,4.129-4.253C141.792,139.866,143.822,141.77,143.822,144.119z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 128.938,
    cy: 146.953,
    r: 4.253
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#42403F"
    },
    cx: 150.201,
    cy: 146.953,
    r: 4.252
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M139.445,149.79c-0.17,0,0.166,0.017,0,0.025V168.9c0.166,0.009-0.17,0.025,0,0.025 c5.285,0,9.693-4.283,9.693-9.568C149.138,154.073,144.73,149.79,139.445,149.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M139.445,139.866c-0.172,0,0.166,0.03,0,0.051v8.403c0.166,0.02-0.172,0.051,0,0.051 c2.348,0,4.377-1.903,4.377-4.252C143.822,141.77,141.792,139.866,139.445,139.866z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#232221"
    },
    cx: 150.201,
    cy: 146.953,
    r: 4.252
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC5918"
    },
    d: "M50.404,5.341c-0.188-0.042-0.339-0.068-0.448-0.075C34.529,4.19,26.758,27.097,23.178,38.567 c-2.612,8.373-1.812,21.498,7.885,25.279c20.197,7.875,25.8-39.129,29.334-51.001c0.269-0.304,0.537-0.606,0.807-0.912 C63.061,9.828,53.076,5.937,50.404,5.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#774730"
    },
    d: "M119.923,5.341c0.188-0.042,0.339-0.068,0.448-0.075c15.427-1.075,23.197,21.831,26.777,33.302 c2.612,8.373,1.811,21.498-7.885,25.279c-20.197,7.875-25.8-39.129-29.334-51.001c-0.269-0.304-0.537-0.606-0.807-0.912 C107.266,9.828,117.251,5.937,119.923,5.341z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5742A"
    },
    d: "M84.57,0C58.955,0.191,38.066,20.189,38.066,44.842c0,24.652,20.889,44.65,46.504,44.842V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AC5918"
    },
    d: "M84.57,0c25.615,0.191,46.504,20.189,46.504,44.842c0,24.652-20.889,44.65-46.504,44.842V0z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AC5918"
    },
    cx: 64.563,
    cy: 35.12,
    r: 14.667
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211A18"
    },
    d: "M71.498,40.688c0.005,1.967-1.584,3.565-3.551,3.569l0,0c-1.967,0.007-3.566-1.584-3.572-3.55 l-0.018-6.233c-0.005-1.967,1.587-3.565,3.554-3.572l0,0c1.966-0.004,3.564,1.586,3.57,3.553L71.498,40.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#211A18"
    },
    d: "M104.783,40.595c0.006,1.967-1.586,3.566-3.551,3.571l0,0c-1.969,0.006-3.566-1.585-3.574-3.551 l-0.016-6.232c-0.006-1.968,1.585-3.566,3.552-3.571l0,0c1.968-0.007,3.567,1.583,3.572,3.55L104.783,40.595z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE5B5"
    },
    d: "M84.57,47.048C70.8,47.119,59.572,54.66,59.572,63.953c0,9.295,11.229,16.835,24.998,16.907 V47.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD5B3"
    },
    d: "M84.57,47.048c13.771,0.071,24.999,7.612,24.999,16.905c0,9.295-11.229,16.835-24.999,16.907 V47.048z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42403F"
    },
    d: "M83.917,44.326c-6.674,0.241-11.978,4.086-11.978,8.794c0,4.709,5.304,8.555,11.978,8.795V44.326z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232221"
    },
    d: "M83.917,44.326c6.674,0.241,11.979,4.086,11.979,8.794c0,4.709-5.305,8.555-11.979,8.795V44.326z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.db44c2d794b583a9b93e530c58a23cd6.svg";
export { ForwardRef as ReactComponent };